import { BaseContainerModel } from "../base-container.model";
import {
  bl_wms_warehouse_node_type_hdr_RowClass,
  bl_wms_warehouse_node_type_hdr_RowInterface,
} from "../../dbschema/index";

export class WarehouseNodeTypeContainerModel extends BaseContainerModel {
  bl_wms_warehouse_node_type_hdr: bl_wms_warehouse_node_type_hdr_RowInterface =
    new bl_wms_warehouse_node_type_hdr_RowClass();
}
